<template>
  <div class="">

    <div class="flex items-center">
      <div class="text-lg mr-4">
        Liabilities - {{ getApplicantName(getClientPrimaryApplicant) }}
      </div>

      <NoteIcon page="liabilities" />
    </div>

    <div class="mt-8">
      <template v-if="liabilities == null" />

      <template v-else-if="liabilities != null && liabilities.length == 0">
        <div class="text-gray-700 text-base bg-gray-200 p-6 rounded border border-gray-300 text-center">

          <img src="https://cdn0.iconfinder.com/data/icons/25-essential-ui-pack-1/32/Delete-512.png" 
            class="w-12 inline" />

          <div class="mt-4">
            You have not added any liabilities. <br/>
            <a href="#" @click.prevent="showAddLiabilityModal" class="underline">Let's add one now</a>.
          </div>

          <template v-if="templates != null && templates.length > 0 && $store.state.view == 'broker'">
            <div class="mt-2 text-base">
              You can also add liabilities via templates that you have created.
            </div>

            <div class="mt-2">
              <select v-on:change="templateSelected($event.target.value)" class="border border-gray-500">
                <option>Select a template</option>
                <template v-for="(template, index) in templates">
                  <option :value="template.id">{{ template.name }}</option>
                </template>
              </select>
            </div>
          </template>
        </div>
      </template>

      <template v-else>

        <div class="mb-4">
          <TotalRow :showAddLiabilityModal="showAddLiabilityModal" :liabilities="liabilities" />
        </div>

        <draggable 
          v-model="liabilities" 
          @end="liabilityMoved"
          :options="{handle:'.move-handler'}">

          <template v-for="(liability, index) in liabilities">
            <div :class="{ 'mt-8' : index > 0 }">
              <template v-if="liability.type == 0">
                <PropertyLoan 
                  :index="index"
                  :objectId="liability.id"
                  :liability="liability"
                  :updateValue="updateValue"
                  :deleteLiability="deleteLiability" />
              </template>

              <template v-else-if="liability.type == 1">
                <CreditCard 
                  :index="index"
                  :objectId="liability.id"
                  :liability="liability"
                  :updateValue="updateValue"
                  :deleteLiability="deleteLiability" />
              </template>

              <template v-else-if="liability.type == 2">
                <CarLease 
                  :index="index"
                  :objectId="liability.id"
                  :liability="liability"
                  :updateValue="updateValue"
                  :deleteLiability="deleteLiability" />
              </template>

              <template v-else-if="liability.type == 3">
                <PersonalLoan 
                  :index="index"
                  :objectId="liability.id"
                  :liability="liability"
                  :updateValue="updateValue"
                  :deleteLiability="deleteLiability" />
              </template>

              <template v-else-if="liability.type == 6">
                <BuyNowPayLater 
                  :index="index"
                  :objectId="liability.id"
                  :liability="liability"
                  :updateValue="updateValue"
                  :deleteLiability="deleteLiability" />
              </template>

              <template v-else>
                <OtherHecs 
                  :index="index"
                  :objectId="liability.id"
                  :liability="liability"
                  :updateValue="updateValue"
                  :deleteLiability="deleteLiability" />
              </template>
            </div>
          </template>
        </draggable>

        <div class="mt-4">
          <TotalRow :showAddLiabilityModal="showAddLiabilityModal" :liabilities="liabilities" />
        </div>

        <!-- <div class="mt-8 p-4 bg-gray-100 border">
          <PageComment page='liabilities'></PageComment>
        </div> -->

        <div class="button-line">
          <ApplicationButton />
        </div>

        <br/><br/><br/>
      </template>
    </div>

    <AddLiabilityModal :templates="templates" :templateSelected="templateSelected" />
  </div>
</template>

<script>
  import PropertyLoan       from './liability-types/PropertyLoan'
  import CreditCard         from './liability-types/CreditCard'
  import CarLease           from './liability-types/CarLease'
  import PersonalLoan       from './liability-types/PersonalLoan'
  import BuyNowPayLater     from './liability-types/BuyNowPayLater'
  import OtherHecs          from './liability-types/OtherHecs'
  import { EventBus }       from '@/shared/event-bus'
  import draggable          from 'vuedraggable'
  import TotalRow           from './TotalRow'
  import ApplicationButton  from '@/shared/components/form/ApplicationButton'
  import AddLiabilityModal  from './AddLiabilityModal'
  import NoteIcon           from '@/shared/components/NoteIcon'

  export default {

    components: {
      PropertyLoan,
      CreditCard,
      CarLease,
      PersonalLoan,
      BuyNowPayLater,
      OtherHecs,
      draggable,
      TotalRow,
      ApplicationButton,
      AddLiabilityModal,
      NoteIcon
    },

    data() {
      return {
        liabilities: null,
        templates  : null
      }
    },

    created() {

      this.logActivity({
        type        : 'liability-visited',
        clientId    : this.$route.params.clientId,
        currentView : this.$store.state.view
      })

      this.getLiabilities()

      if(this.$store.state.view == 'broker') {
        this.getTemplates()
      }
    },

    methods : {
      getLiabilities() {
        this.showLoader("Loading liabilities...")
        this.apiGet({
          clientId : this.$route.params.clientId
        }, 'liability/list', (liabilities) => {
          this.hideLoader()
          this.liabilities = liabilities       
        })
      },

      getTemplates() {
        this.apiGet({
          type : "liability"
        }, 'template/list', (templates) => {
          this.templates = templates       
        })
      },

      templateSelected(value) {
        if(value != null) {
          this.showLoader("Applying template...")
          this.apiPost({
            clientId  : this.$route.params.clientId,
            templateId: value
          }, 'liability/apply-template', (liabilities) => {
            this.hideLoader()
            this.liabilities = liabilities
          })
        }
      },

      showAddLiabilityModal() {
        this.$modal.show('add-liability-modal', {
          addLiability : this.addLiability
        })
      },

      addLiability(type) {
        this.showLoader("Adding a liability...")
        this.apiPost({
          clientId : this.$route.params.clientId,
          type     : type,          
        }, 'liability/create', (liability) => {
          this.hideLoader()
          this.liabilities.push(liability)
        })
      },

      updateValue(params) {
        if(this.liabilities[params.index][params.key] != params.value) {
          EventBus.$emit('set-autosave', true)
          this.apiPost({
            clientId   : this.$route.params.clientId,
            key        : params.key,
            value      : params.value,
            liabilityId: params.objectId
          }, 'liability/edit', (liability) => {
            let liabilities           = _.cloneDeep(this.liabilities)
            liabilities[params.index] = liability
            this.liabilities          = liabilities
            EventBus.$emit('set-autosave', false)
          })
        }
      },

      liabilityMoved(event) {
        let ids = []
        for(let i=0; i < this.liabilities.length; i++) {
          ids.push(this.liabilities[i].id)
        }

        EventBus.$emit('set-autosave', true)
        this.apiPost({
          clientId    : this.$route.params.clientId,
          liabilityIds: ids.join(",")
        }, 'liability/change-order', () => {
          EventBus.$emit('set-autosave', false)
        })
      },

      deleteLiability(liabilityId, index) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientId   : this.$route.params.clientId,
                liabilityId: liabilityId
              }, 'liability/delete', () => {
                this.$modal.hide('confirm-modal')
                this.liabilities.splice(index, 1)
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Liability deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    },

    metaInfo () {
      return {
        title: 'Liabilities - ' + (this.getClientPrimaryApplicant != null ? this.getApplicantName(this.getClientPrimaryApplicant) : '') + " | Brokerpad"
      }
    }
  }
</script>